import { Component, OnInit } from '@angular/core';
import { url } from 'src/environments/environment';

@Component({
  selector: 'app-home-nav',
  templateUrl: './home-nav.component.html',
  styleUrls: ['./../home/home.page.scss'],
})
export class HomeNavComponent implements OnInit {
web = url.web;

  constructor() { }

  ngOnInit() {}

}
